import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Sun, Eye, EyeOff, Loader2 } from 'lucide-react';
import toast from 'react-hot-toast';
import PasswordReset from './PasswordReset';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showReset, setShowReset] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error('Completa todos los campos');
    setLoading(true);
    try {
      await login(email, password);
      toast.success('¡Bienvenido a Bitácora Solar!');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  if (showReset) return <PasswordReset onBack={() => setShowReset(false)} />;

  return (
    <div className="login-page">
      <div className="login-bg">
        <div className="solar-grid" />
      </div>
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <div className="login-logo">
              <Sun size={48} />
            </div>
            <h1>Bitácora Solar</h1>
            <p style={{ fontSize: '11px', letterSpacing: '3px', textTransform: 'uppercase', color: '#94a3b8', marginBottom: '4px' }}>by ENERGESTICS</p>
            <p>Gestión de Construcción de Plantas Fotovoltaicas</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label>Correo electrónico</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="tu@email.com"
                autoComplete="email"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label>Contraseña</label>
              <div className="input-with-icon">
                <input
                  type={showPass ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  autoComplete="current-password"
                  disabled={loading}
                />
                <button type="button" className="toggle-pass" onClick={() => setShowPass(!showPass)}>
                  {showPass ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
              {loading ? <><Loader2 size={18} className="spin" /> Iniciando...</> : 'Iniciar sesión'}
            </button>
            <button type="button" className="pr-link" style={{ marginTop: '12px', display: 'block', textAlign: 'center', width: '100%' }} onClick={() => setShowReset(true)}>
              {'¿Olvidaste tu contraseña?'}
            </button>
          </form>

          <div className="login-footer">
            <p>© {new Date().getFullYear()} Energestics · Bitácora Solar v1.0</p>
          </div>
        </div>
      </div>
    </div>
  );
}
